module.exports = __webpack_public_path__ + "static/img/img-chanping.746b7ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-chanping.png
// module id = 434
// module chunks = 2